module.exports = __webpack_public_path__ + "static/media/pdf_icon.b64c4c0b.svg";